import Shell from './ui/AppShell';

export default function App() {
  return <Shell />;
}
